// Parse ISO timestamps without interpreting an unzoned server timestamp locally.
export const publicDate = (value) => {
  if (typeof value !== "string") return null;
  const text = value.trim();
  const parts = text.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2})(?:\.\d+)?)?(?:Z|[+-]\d{2}:\d{2})?)?$/);
  if (!parts) return null;
  const [, year, month, day, hour = "00", minute = "00", second = "00"] = parts;
  if (+month < 1 || +month > 12 || +day < 1 || +day > new Date(Date.UTC(+year, +month, 0)).getUTCDate()
    || +hour > 23 || +minute > 59 || +second > 59) return null;
  let iso = text.replace(" ", "T");
  if (!iso.includes("T")) iso += "T00:00:00Z";
  else if (!/(Z|[+-]\d{2}:\d{2})$/.test(iso)) iso += "Z";
  const date = new Date(iso);
  return Number.isFinite(date.getTime()) ? date : null;
};